function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#97999B",
  d: "M12 2c5.43 0 9.848 4.325 9.996 9.72L22 12c0 5.43-4.325 9.848-9.72 9.996L12 22c-5.43 0-9.848-4.325-9.996-9.72L2 12c0-5.43 4.325-9.848 9.72-9.996L12 2zm0 1l-.252.003C6.893 3.137 3 7.113 3 12l.003.252C3.137 17.107 7.113 21 12 21l.252-.003C17.107 20.863 21 16.887 21 12l-.003-.252C20.863 6.893 16.887 3 12 3zm-.144 4.352c1.19 0 1.19 0 1.88.624.692.624.692.624.692 1.66 0 1.26 0 1.26-1.605 3l-2.286 2.48h4.284V16H9.23v-.78l2.953-3.28.158-.182c.53-.62.53-.62.747-1.029.25-.465.25-.465.25-.963 0-.668 0-.668-.405-1.096-.404-.428-.404-.428-1.078-.428-.809 0-.809 0-1.257.46-.448.46-.448.46-.448 1.28H9.067l.006-.21c.063-1.033.063-1.033.752-1.694.76-.726.76-.726 2.03-.726z"
});
const SvgIconDevIcStepperTwo = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconDevIcStepperTwo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-dev-ic-stepper-two.a9e90b7b.svg";
export { ForwardRef as ReactComponent };